<po-page-default
  [p-breadcrumb]="breadcrumb"
  p-title="NF de Entrada para Romaneio"
>

  <po-combo class="po-sm-12 po-md-12 po-lg-12"
    name="CDOCSERIE"
    p-label="Nota Fiscal"
    [(ngModel)]="CDOCSERIE"
    p-icon="po-icon-search"
    p-field-label="label"
    p-field-value="value"
    p-filter-service="{{urlApiProtheus}}/wsrromaneio/nf-entrada/listacombo"
    p-disabled-init-filter="false"
    p-infinite-scroll="true"
    p-required="true"
    (p-change)="escolheNota()"
  ></po-combo>

  <po-table
    class="po-md-12"
    [p-columns]="colunasItems"
    [p-items]="romaneioNF.items"
    [p-height]="500"
    p-spacing="small"
    [p-container]="true"
    [p-hide-table-search]="false"
  ></po-table>
  
  <po-button
    class="po-md-12"
    p-label="Gerar"
    p-kind="primary"
    (p-click)="gerarRomaneio()"
    [p-disabled]="romaneioNF.items.length==0"
  ></po-button>



</po-page-default>
